// VNEC v9 — pages/vat-tu.js
// Form tạo/sửa vật tư trong vat_tu_catalog
import { supabase } from '../lib/supabase.js';
import { esc } from '../lib/forms.js';
import { ok, err } from '../components/toast.js';

export async function renderVatTuForm(maVatTu) {
  window.__pageInit = () => init(maVatTu);
  const isNew = !maVatTu || maVatTu === 'new';
  return `
    <div class="page">
      <div class="page-header">
        <h1>${isNew ? 'Thêm vật tư mới' : 'Sửa vật tư'}</h1>
        <a href="#/kho" class="btn btn-ghost btn-sm">← Danh sách</a>
      </div>
      <div class="card" style="max-width:640px">
        <form id="vt-form">
          <div class="field">
            <label>Mã vật tư <span style="color:#A32D2D">*</span></label>
            <input type="text" id="vt-ma" required maxlength="50" ${isNew ? '' : 'readonly style="background:#F5F5F0"'}
                   placeholder="VD: VT-XM-PCB30">
            <p class="muted small">Quy ước: VT-{nhóm}-{tên ngắn}. Không có dấu cách. Không sửa được sau khi tạo.</p>
          </div>

          <div class="field">
            <label>Tên vật tư <span style="color:#A32D2D">*</span></label>
            <input type="text" id="vt-ten" required maxlength="200" placeholder="VD: Xi măng PCB30 Hoàng Thạch">
          </div>

          <div class="grid-2">
            <div class="field">
              <label>Đơn vị tính</label>
              <input type="text" id="vt-dvt" maxlength="20" placeholder="Bao, Kg, m³, Viên...">
            </div>
            <div class="field">
              <label>Nhóm</label>
              <input type="text" id="vt-nhom" maxlength="50" list="nhom-list" placeholder="Xi măng, Thép, Cát đá...">
              <datalist id="nhom-list"></datalist>
            </div>
          </div>

          <div class="field">
            <label class="checkbox-label">
              <input type="checkbox" id="vt-active" checked>
              Đang sử dụng (uncheck để vô hiệu hóa)
            </label>
          </div>

          <div class="form-actions">
            <button type="submit" class="btn btn-primary" id="vt-save">${isNew ? '+ Tạo vật tư' : 'Lưu thay đổi'}</button>
            <a href="#/kho" class="btn btn-ghost">Hủy</a>
          </div>
        </form>
      </div>
    </div>`;
}

async function init(maVatTu) {
  const isNew = !maVatTu || maVatTu === 'new';

  // Load nhom suggestions
  const { data: existing } = await supabase.from('vat_tu_catalog').select('nhom').limit(1000);
  const nhoms = [...new Set((existing || []).map(v => v.nhom).filter(Boolean))];
  const dl = document.getElementById('nhom-list');
  nhoms.forEach(n => {
    const opt = document.createElement('option');
    opt.value = n;
    dl.appendChild(opt);
  });

  // If edit, load existing
  if (!isNew) {
    const { data, error } = await supabase.from('vat_tu_catalog')
      .select('*').eq('ma_vat_tu', maVatTu).maybeSingle();
    if (error || !data) {
      err('Không tìm thấy vật tư: ' + (error?.message || maVatTu));
      return;
    }
    document.getElementById('vt-ma').value = data.ma_vat_tu;
    document.getElementById('vt-ten').value = data.ten_vat_tu || '';
    document.getElementById('vt-dvt').value = data.don_vi || '';
    document.getElementById('vt-nhom').value = data.nhom || '';
    document.getElementById('vt-active').checked = data.is_active !== false;
  }

  document.getElementById('vt-form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = document.getElementById('vt-save');
    btn.disabled = true;
    btn.textContent = 'Đang lưu...';

    const payload = {
      ma_vat_tu: document.getElementById('vt-ma').value.trim(),
      ten_vat_tu: document.getElementById('vt-ten').value.trim(),
      don_vi: document.getElementById('vt-dvt').value.trim() || null,
      nhom: document.getElementById('vt-nhom').value.trim() || null,
      is_active: document.getElementById('vt-active').checked
    };

    if (!payload.ma_vat_tu || !payload.ten_vat_tu) {
      err('Mã VT và Tên là bắt buộc');
      btn.disabled = false;
      btn.textContent = isNew ? '+ Tạo vật tư' : 'Lưu thay đổi';
      return;
    }
    if (/\s/.test(payload.ma_vat_tu)) {
      err('Mã VT không được có dấu cách');
      btn.disabled = false;
      btn.textContent = isNew ? '+ Tạo vật tư' : 'Lưu thay đổi';
      return;
    }

    try {
      let result;
      if (isNew) {
        result = await supabase.from('vat_tu_catalog').insert(payload);
      } else {
        const { ma_vat_tu, ...updateData } = payload;
        result = await supabase.from('vat_tu_catalog').update(updateData).eq('ma_vat_tu', maVatTu);
      }
      if (result.error) throw result.error;
      ok(isNew ? 'Đã tạo vật tư: ' + payload.ma_vat_tu : 'Đã cập nhật');
      setTimeout(() => { window.location.hash = '#/kho'; }, 600);
    } catch (e) {
      err('Lỗi: ' + e.message);
      btn.disabled = false;
      btn.textContent = isNew ? '+ Tạo vật tư' : 'Lưu thay đổi';
    }
  });
}
